import { render, staticRenderFns } from "./tableOperations.vue?vue&type=template&id=022d9017"
import script from "./tableOperations.vue?vue&type=script&lang=ts"
export * from "./tableOperations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports